import type { StepProps } from "../types";
import { Field, Select, Textarea } from "@/components/ui";

const BLOOD_TYPES = ["O+", "O-", "A+", "A-", "B+", "B-", "AB+", "AB-"] as const;

export default function Step4EmergencyMedical({ context, draft, updateField }: StepProps) {
  const emp = context.employee;

  return (
    <div>
      <p className="text-text-muted text-sm mb-2">
        Strongly recommended but optional. Helps supervisors respond quickly in an emergency.
      </p>

      <div className="grid gap-4 grid-cols-1 md:grid-cols-2">
        <Field label="Blood type">
          <Select
            value={draft.blood_type ?? emp?.blood_type ?? ""}
            onChange={e => updateField("blood_type", e.target.value)}
          >
            <option value="">—</option>
            {BLOOD_TYPES.map(bt => (
              <option key={bt} value={bt}>{bt}</option>
            ))}
          </Select>
        </Field>

        <div className="md:col-span-2">
          <Field label="Emergency medical notes">
            <Textarea
              rows={4}
              placeholder="Allergies, medications, conditions supervisors should know about in an emergency"
              value={draft.emergency_medical_notes ?? emp?.emergency_medical_notes ?? ""}
              onChange={e => updateField("emergency_medical_notes", e.target.value)}
            />
          </Field>
        </div>
      </div>
    </div>
  );
}
